import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { i18n } from './i18n'
import { createRouter, createWebHashHistory } from 'vue-router'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'
import axios from "axios";
window.axios = axios;
import App from './components/App.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'summernote/dist/summernote-bs5.min.css'
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/leaflet.js'
import 'animate.css';
import '../stil.css'
import {config} from "@/config";

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

const adminPoti = [
    '/Nastavitve/Administracija/Upravljalci',
    '/Nastavitve/Administracija/Dvostopenjska',
    '/Nastavitve/Administracija/UpravljalciLetal',
    '/Nastavitve/Administracija/VnosLicenc',
    '/urednik/Pregled_dostopov',
    '/Pravice/DeaktiviraniUporabniki',
    '/urednik/Changelog'
];
const zascitenaPot = (pot) => {
    return adminPoti.some(route =>
        pot === route || pot.startsWith(route + '/')
    );
};
router.beforeEach((to) => {
    let userJson = null;
    if(config.User) {
        userJson = config.FullUser;
    }else {
         userJson = localStorage.getItem('User');
         if(userJson) {
             try {
                 const user = JSON.parse(userJson);

                 config.User = user.email;
                 config.FullUser = user;
                 config.UserLVL = user.lvl;
                 config.UserID = user.id;
                 config.PwrUser = user.lvl === 0;
             } catch (error) {
                 console.error('Invalid User data:', error);
                 localStorage.removeItem('User');
                 userJson = null;
             }
         }
    }

    if (!userJson && to.path !== '/Login') {
        return '/Login';
    }
    if (zascitenaPot(to.path) && config.PwrUser !== true) {
        return ('/');
    }

    return true;
});

const app = createApp(App)

app.use(i18n)
app.use(router)

app.mount('#SkyScribe')
